import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0F1A] flex items-center justify-center px-4">
      <div className="absolute top-1/4 left-1/3 w-80 h-80 bg-[#00E5FF] rounded-full blur-[200px] opacity-[0.05]"></div>
      <div className="text-center relative z-10">
        <h1 className="text-[120px] sm:text-[160px] font-bold font-['Space_Grotesk'] leading-none bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent" data-testid="404-heading">
          404
        </h1>
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">Page Not Found</h2>
        <p className="text-[#9CA3AF] max-w-md mx-auto mb-8">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="bg-[#00E5FF] hover:bg-[#1DE9B6] text-[#0B0F1A] font-semibold px-8 py-5 text-base rounded-lg shadow-lg shadow-[#00E5FF]/40">
              <Home className="w-4 h-4 mr-2" /> Back to Home
            </Button>
          </Link>
          <Link to="/book-a-consultation">
            <Button className="border-2 border-[#00E5FF] text-[#00E5FF] hover:bg-[#00E5FF]/10 px-8 py-5 text-base rounded-lg bg-transparent">
              <ArrowLeft className="w-4 h-4 mr-2" /> Book Consultation
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
